<template>
    <custom-modal class="custom-modal__extended" id="report-params-modal" ref="modalRef" v-b-modal.modal-center
        :title="modalTitle" :hide-backdrop="false" @accept="() => { }" @hide="onHideHandler">
        <div id="report-params-container" class="font-14 border-bottom pb-4">
            <validation-observer ref="formRef" v-slot="{ }" tag="form">
                <!-- Date Range for Dashboard, Efficiency, Services -->
                <div v-if="showDateRange" class="row mt-4">
                    <div class="col-md-6">
                        <validation-provider rules="required" v-slot="{ errors }">
                            <div class="color-primary-4 font-14 font-weight-bold mb-1">
                                Desde:
                            </div>
                            <custom-date-picker v-model="model.dateFrom" class="input__extended"
                                placeholder="DD/MM/YYYY" class-container="w-100" :error="errors[0]"
                                :custom-error-msg="`${$t('RequiredField')}.`" />
                        </validation-provider>
                    </div>
                    <div class="col-md-6">
                        <validation-provider rules="required" v-slot="{ errors }">
                            <div class="color-primary-4 font-14 font-weight-bold mb-1">
                                Hasta:
                            </div>
                            <custom-date-picker v-model="model.dateTo" class="input__extended" placeholder="DD/MM/YYYY"
                                class-container="w-100" :error="errors[0]"
                                :custom-error-msg="`${$t('RequiredField')}.`" />
                        </validation-provider>
                    </div>
                </div>

                <!-- Claim ID for History -->
                <div v-if="showClaimId" class="row mt-4">
                    <div class="col-md-12">
                        <validation-provider rules="required" v-slot="{ errors }">
                            <div class="color-primary-4 font-14 font-weight-bold mb-1">
                                Número de Reclamo (Claim ID):
                            </div>
                            <custom-input v-model="model.claimId" class="input__extended"
                                placeholder="Ej: CIIE-2024-001" :error="errors[0]"
                                :custom-error-msg="`${$t('RequiredField')}.`" />
                        </validation-provider>
                    </div>
                </div>
            </validation-observer>
        </div>
        <template #footer>
            <div class="d-flex align-items-center justify-content-center pb-3">
                <action-button class="btn-warning-outline outline-warning px-3 py-2" i="fa fa-times-circle"
                    text="Cancelar" @click="hideModal" />

                <action-button class="btn-success px-4 py-2 ml-4" text="Generar Reporte" i="fa fa-check-circle"
                    @click="onGenerateHandler" />
            </div>
        </template>
    </custom-modal>
</template>

<script>
//libs
import { i18n } from '@/i18n';
import ActionButton from 'ActionButton';
import CustomDatePicker from 'custom-date-picker';
import CustomInput from 'CustomInput';

//common components
import { CustomModal } from '@/components/common';

//utils
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin';

export default {
    name: 'ReportsParamsModal',
    mixins: [alertMixin],
    components: {
        CustomModal,
        ActionButton,
        CustomDatePicker,
        CustomInput
    },
    data: () => ({
        reportType: null,
        model: {
            dateFrom: null,
            dateTo: null,
            claimId: null,
        },
    }),
    computed: {
        modalTitle() {
            switch (this.reportType) {
                case 'dashboard':
                    return 'Tablero de Control';
                case 'efficiency':
                    return 'Eficiencia Técnica';
                case 'services':
                    return 'Reporte de Servicios';
                case 'history':
                    return 'Historial de Reclamo';
                default:
                    return 'Generar Reporte';
            }
        },
        showDateRange() {
            return ['dashboard', 'efficiency', 'services'].includes(this.reportType);
        },
        showClaimId() {
            return this.reportType === 'history';
        }
    },
    methods: {
        showModal(type) {
            this.reportType = type;
            this.model = {
                dateFrom: null,
                dateTo: null,
                claimId: null,
            };
            this.$refs.modalRef.showModal();
        },
        hideModal() {
            this.$refs.modalRef.hideModal();
        },
        onHideHandler() {
            this.reportType = null;
            if (this.$refs.formRef) {
                this.$refs.formRef.reset();
            }
        },
        async onGenerateHandler() {
            const isValid = await this.$refs.formRef.validate();
            if (!isValid) {
                this.ShowToast(
                    i18n.t('Alert'),
                    `${i18n.t('PleaseCompleteRequestedInformation')}.`,
                    'error'
                );
                return;
            }

            this.$emit('generate', {
                type: this.reportType,
                params: { ...this.model }
            });
            this.hideModal();
        }
    }
};
</script>

<style scoped lang="scss">
@import '@/scss/components/action-button/index.scss';
@import '@/scss/bootstrap/_colors.scss';

.input__extended {
    ::v-deep .form-control {
        height: 38px;
    }
}
</style>
